import { ReactElement, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../../assets/css/success-stories.css";
import { getSuccessStories, SuccessStoryView } from "../../Services/PublicSuccessStories";
import SuccessStoriesBanner from "./components/SuccessStoriesBanner";
import SuccessStoriesList from "./components/SuccessStoriesList";

export default function SuccessStoriesPage(): ReactElement {
  const [params] = useSearchParams();
  const storyId = params.get("n1") || "";
  const [stories, setStories] = useState<SuccessStoryView[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "WSG Collaborations";
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    getSuccessStories(storyId).then((result) => {
      if (!cancelled) {
        setStories(result.stories);
      }
    }).catch(() => {
      if (!cancelled) {
        setError("The success stories could not be loaded.");
      }
    }).finally(() => {
      if (!cancelled) {
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [storyId]);

  return (
    <div className="success-stories-page">
      <div className="success-stories-hero" aria-hidden="true" />
      <SuccessStoriesBanner />
      <section className="success-stories-sheet">
        <h2 className="success-stories-heading">
          <span>Success Stories</span>
          <Link className="success-stories-submit" to="/submit_stories.asp?action=add">
            Submit a Success story
          </Link>
        </h2>
        <SuccessStoriesList stories={stories} loading={loading} error={error} />
        <img className="success-stories-dots" src="https://members-legacy.worldservicesgroup.com/assets/images/dots.png" alt="dots" />
      </section>
    </div>
  );
}
